module.exports = __webpack_public_path__ + "intro-banner-01.f54ea2d0dbe9c4415ac3.jpg";


//////////////////
// WEBPACK FOOTER
// D:/sachin/umc-new/umc/src/assets/images/intro-banner-01.jpg
// module id = ../../../../../src/assets/images/intro-banner-01.jpg
// module chunks = styles